<template>
  <div class="timepicker">
    <div class="timepicker-picker">
      <table class="table-condensed">
        <tr>
          <td>
            <a
              href="#"
              tabindex="-1"
              class="btn"
              @click.prevent="incrementHour"
            >
              <span class="glyphicon glyphicon-chevron-up"></span>
            </a>
          </td>
          <td class="separator"></td>
          <td>
            <a
              href="#"
              tabindex="-1"
              class="btn"
              @click.prevent="incrementMinute"
            >
              <span class="glyphicon glyphicon-chevron-up"></span>
            </a>
          </td>
          <td class="separator"></td>
        </tr>
        <tr>
          <td>
            <span class="timepicker-hour" @click="emitChange()">{{
              hour
            }}</span>
          </td>
          <td class="separator">:</td>
          <td>
            <span class="timepicker-minute" @click="emitChange()">{{
              minute
            }}</span>
          </td>
          <td v-if="period !== null">
            <button
              class="btn btn-primary"
              tabindex="-1"
              @click.prevent="togglePeriod"
            >
              {{ period }}
            </button>
          </td>
        </tr>
        <tr>
          <td>
            <a
              href="#"
              tabindex="-1"
              class="btn"
              @click.prevent="decrementHour"
            >
              <span class="glyphicon glyphicon-chevron-down"></span>
            </a>
          </td>
          <td class="separator"></td>
          <td>
            <a
              href="#"
              tabindex="-1"
              class="btn"
              @click.prevent="decrementMinute"
            >
              <span class="glyphicon glyphicon-chevron-down"></span>
            </a>
          </td>
          <td class="separator"></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { sprintf } from 'sprintf-js'

export default {
  name: 'TimePicker',
  props: {
    currentDate: {
      default: () => moment()
    },
    use24Hour: {
      type: Boolean,
      default: false
    }
  },
  data() {
    if (this.use24Hour) {
      return {
        hour: this.currentDate.format('HH'),
        minute: this.currentDate.format('mm'),
        period: null
      }
    } else {
      return {
        hour: this.currentDate.format('hh'),
        minute: this.currentDate.format('mm'),
        period: this.currentDate.format('A')
      }
    }
  },
  methods: {
    togglePeriod() {
      this.period = this.period === 'AM' ? 'PM' : 'AM'

      this.emitChange()
    },
    incrementHour() {
      const switchHour = this.use24Hour ? 23 : 12
      const startFromHour = this.use24Hour ? 0 : 1

      if (parseInt(this.hour) === switchHour) {
        this.hour = sprintf('%02d', startFromHour)
      } else {
        this.hour = sprintf('%02d', parseInt(this.hour) + 1)
      }

      this.emitChange()
    },
    decrementHour() {
      const switchHour = this.use24Hour ? 23 : 12
      const startFromHour = this.use24Hour ? 0 : 1

      if (parseInt(this.hour) === 1) {
        this.hour = sprintf('%02d', switchHour)
      } else {
        this.hour = sprintf('%02d', parseInt(this.hour) - 1)
      }

      this.emitChange()
    },
    incrementMinute() {
      if (parseInt(this.minute) === 59) {
        this.minute = sprintf('%02d', 0)
      } else {
        this.minute = sprintf('%02d', parseInt(this.minute) + 1)
      }

      this.emitChange()
    },
    decrementMinute() {
      if (parseInt(this.minute) === 0) {
        this.minute = sprintf('%02d', 59)
      } else {
        this.minute = sprintf('%02d', parseInt(this.minute) - 1)
      }

      this.emitChange()
    },
    emitChange() {
      this.$emit(
        'change',
        `${this.hour}:${this.minute}${
          this.period !== null ? ` ${this.period}` : ''
        }`
      )
    }
  }
}
</script>

<style lang="scss">
.timepicker {
  color: #2d353c;
  min-width: 250px !important;
  border-radius: 6px !important;
  padding: 0 !important;

  .timepicker-picker {
    padding: 5px;
  }
}
</style>
